import { render, staticRenderFns } from "./area-component.vue?vue&type=template&id=779089d6&scoped=true&"
import script from "./area-component.vue?vue&type=script&lang=js&"
export * from "./area-component.vue?vue&type=script&lang=js&"
import style0 from "./area-component.vue?vue&type=style&index=0&id=779089d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779089d6",
  null
  
)

export default component.exports